import { BaseError } from "../base/BaseError";

export class ServerError extends BaseError {
    message = "خطأ في الخادم،الرجاء المحاولة مرة أخرى";
}
